var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{staticClass:"sitemap",attrs:{"width":"lg"}},[_c('HeaderSection',{attrs:{"header":_vm.$prismic.asHtml(_vm.slice.primary.h2)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }